<paedml-logout>
  <script>
    import API from '../api'
    import store from '../store'
    
    this.on('mount', () => {
      API.user.logout()
      store.dispatch({type: 'user/logout'})
    })

  </script>

</paedml-logout>
  